import { AuthService } from './auth/auth.service';
var AppComponent = /** @class */ (function () {
    function AppComponent(authService) {
        this.authService = authService;
    }
    return AppComponent;
}());
export { AppComponent };
